import React, { Component } from 'react';
import cx from 'classnames';
import scrollToComponent from 'react-scroll-to-component';

import Button, {
  buttonTypes,
  actionTypes
} from '@bit/fabfitfun.shared.global.button';

// Move into Bit
import ProductContainer from '../ProductContainer/ProductContainer';
import { campaignState } from '../../../../utils/campaignState';
import PageNav from '../PageNav/PageNav';

import analytics, { events } from '../../../../utils/analytics';
import env from '../../../../utils/env';
import { boxExpired } from '../../../../utils/boxStatus';

import './Panel.css';

class PanelView extends Component {
  state = {
    viewAll: false,
    currentPage: 1,
    pageLength: 5, // @TODO Get this number from the CMS
    initialDisplayAmount: 6, // @TODO Get this number from the CMS
  };

  hasPanelItems = panelItems => panelItems && panelItems.length > 0;

  showClosedMessage = (panelItems, openStatus)=>
    !this.hasPanelItems(panelItems) &&
    openStatus === campaignState.CLOSED;

  showNoItemsCTA = (panelItems, openStatus)=>
    openStatus === campaignState.OPEN &&
    !this.hasPanelItems(panelItems);

  getPageItems = (panelItems) => {
    const { currentPage, pageLength } = this.state;

    if (!panelItems || !panelItems.length) {
      return [];
    }

    const start = (currentPage - 1) * pageLength;
    const end = start + pageLength;

    return panelItems.slice(start, end);
  };

  render() {
    const {
      sysdata = {},
      displayOrderSummary,
      panelItems,
      panelName,
      isBoost,
      status,
      hasBeenAssigned,
      closedCTA,
      closedCTASharedBox,
      noItemCTA,
      noItemCTASharedBox,
      reactiveCTA,
      reactivateCTASharedBoxNoItem,
      orderSummary,
      addMore,
      reactivateCTASharedBoxWithItems,
    } = this.props;
    const { userData = {}, isMobile, isProspect, isSharedBox } = sysdata;
    const isExpired = boxExpired(userData);
    const { pageLength, initialDisplayAmount } = this.state;
    const pageItems = this.getPageItems(panelItems);

    const displayAddMore = status === campaignState.OPEN;
    const displayViewButton = !isMobile && !!panelItems
      && panelItems.length > initialDisplayAmount;
    const displaySidebar = displayOrderSummary || displayAddMore;
    const displayPanelItems = this.hasPanelItems(panelItems) && !isExpired;

    const statusContainerStyle = cx({
      'd-flex': isMobile,
      'flex-jsa': isMobile,
    });
    const statusStyle = cx({
      'c-black-60': true,
      'd-flex': true,
      'flex-aic': true,
      'ff-ns': true,
      'fs-16': true,
      'fw-normal': true,
      'case-caps': true,
      'pad-t-4': true
    });

    const titleStyle = cx({
      'mar-0': true,
      'ta-center': isMobile,
      'ff-pds': true,
      'fs-36': true,
      'fw-normal': true,
      'panel-title': true,
    });

    const panelContainerStyle = cx({
      'd-flex': true,
      'flex-jsb': !isMobile,
      'flex-jse': isMobile,
      'flex-fdcr': isMobile,
      'flex-aic': isMobile,
    });

    const productGridWrapperStyle = cx({
      'w-70': !isMobile && (status === campaignState.OPEN || displayPanelItems)
    });

    const closedMsgStyle = cx({
      'closed-msg': true,
      'ta-center': true,
      'mar-a': isMobile,
      mobile: isMobile,
    });

    return (
      <div className="add-ons-panel">
        <div className="mar-h-16">
          <h1
            ref={section => {
              this.Header = section;
            }}
            className={titleStyle}
          >
            {panelName}
          </h1>
          <div className={statusContainerStyle}>
            <div className={statusStyle}>
              Status: {status}
              <div className={`status-light ${status} mar-4`}>&nbsp;</div>
            </div>
          </div>
        </div>

        {/* Season is closed */}
        {this.showClosedMessage(panelItems, status) && !isExpired && !isProspect && (
          <div className={closedMsgStyle}>
            {closedCTA}
          </div>
        )}

        {/* Season is closed but I am a prospect looking at a shared box  */}
        {this.showClosedMessage(panelItems, status) && !isExpired && isProspect && (
          <div className={closedMsgStyle}>
            {closedCTASharedBox}
          </div>
        )}

        {/* Season is open but I have no items */}
        {this.showNoItemsCTA(panelItems, status) && !isExpired && !isProspect && noItemCTA}

        {/* Season is open and this is a shared box */}
        {this.showNoItemsCTA(panelItems) && isProspect && noItemCTASharedBox}

        {/* User's Subscription is Expired */}
        {isExpired && !isSharedBox && reactiveCTA}

        {/* User's Subscription is Expired and is a shared box and the box has no items  */}
        {isExpired && isSharedBox && !this.hasPanelItems(panelItems) && (
          reactivateCTASharedBoxNoItem
        )}

        {/* User's Subscription is Expired and is a shared box and the box has items  */}
        {isExpired && isSharedBox && this.hasPanelItems(panelItems) && (
          <React.Fragment>
            <div className={this.panelContainerStyle}>
              <div className={this.productGridWrapperStyle}>
                <ProductContainer
                  products={isMobile ? pageItems : panelItems}
                  open={status === campaignState.OPEN}
                  viewAll={this.state.viewAll}
                  initialDisplayAmount={this.initialDisplayAmount}
                  isMobile={isMobile}
                  hasBeenAssigned={hasBeenAssigned}
                />
              </div>
              {isMobile
                && this.hasPanelItems(panelItems)
                && panelItems.length > this.pageLength && (
                <PageNav
                  maxPageCount={4}
                  currentPage={this.state.currentPage}
                  totalPages={Math.ceil(
                    panelItems.length / pageLength,
                  )}
                  onChange={pg => {
                    this.setState({ currentPage: pg });
                    scrollToComponent(this.Header, {
                      offset: 0,
                      align: 'top',
                      duration: 500,
                    });
                  }}
                />
              )}

              <br />
              {displaySidebar && <div className="summary-details w-100">
                {displayOrderSummary && orderSummary}
                {displayAddMore && !isProspect && addMore}

                {/* {Has addon items and is prospect member} */}
                {displayAddMore && isProspect && (
                  <Button
                    type={buttonTypes.PRIMARY.value}
                    action={actionTypes.CALL_TO_ACTION.value}
                    label="GET THE BOX"
                    style={{ width: '100%', margin: '12px 0 0' }}
                    onClick={() => {
                      window.location = `${env.envURL}/get-the-box`;
                    }}
                  />
                )}


                {displayViewButton && (
                  <Button
                    type={buttonTypes.SECONDARY.value}
                    action={actionTypes.CALL_TO_ACTION.value}
                    label={!this.state.viewAll ? 'View All' : 'View Less'}
                    style={{ width: '100%', margin: '12px 0 0' }}
                    onClick={() => {
                      this.setState({
                        viewAll: !this.state.viewAll,
                      });
                      analytics.track(events.CLICKED_ELEMENT, {
                        element_name: !this.state.viewAll ? 'View All' : 'View Less',
                        option_title: { panelName },
                      });
                    }}
                  />
                )}
              </div>}
            </div>
          </React.Fragment>
        )}

        {/* User has items */}
        {displayPanelItems && (
          <div className={panelContainerStyle}>
            <div className={productGridWrapperStyle}>
              <ProductContainer
                products={isMobile ? pageItems : panelItems}
                open={status === campaignState.OPEN}
                viewAll={this.state.viewAll}
                initialDisplayAmount={initialDisplayAmount}
                isMobile={isMobile}
                hasBeenAssigned={hasBeenAssigned}
                isSharedBox={isSharedBox}
                isBoost={isBoost}
              />
            </div>
            {isMobile
              && this.hasPanelItems(panelItems)
              && panelItems.length > pageLength && (
                <PageNav
                  maxPageCount={4}
                  currentPage={this.state.currentPage}
                  totalPages={Math.ceil(
                    panelItems.length / pageLength,
                  )}
                  onChange={pg => {
                    this.setState({ currentPage: pg });
                    scrollToComponent(this.Header, {
                      offset: 0,
                      align: 'top',
                      duration: 500,
                    });
                  }}
                />
            )}

            <br />
            {displaySidebar && <div className="summary-details w-100">
              {displayOrderSummary && orderSummary}
              {displayAddMore && !isProspect && addMore}

              {/* {Has addon items and is prospect member} */}
              {displayAddMore && isProspect && (
                <Button
                  type={buttonTypes.PRIMARY.value}
                  action={actionTypes.CALL_TO_ACTION.value}
                  label="GET THE BOX"
                  style={{ width: '100%', margin: '12px 0 0' }}
                  onClick={() => {
                    window.location = `${env.envURL}/get-the-box`;
                  }}
                />
              )}
              {displayViewButton && (
                <Button
                  type={buttonTypes.SECONDARY.value}
                  action={actionTypes.CALL_TO_ACTION.value}
                  label={!this.state.viewAll ? 'View All' : 'View Less'}
                  style={{ width: '100%', margin: '12px 0 0' }}
                  onClick={() => {
                    this.setState({
                      viewAll: !this.state.viewAll,
                    });
                    analytics.track(events.CLICKED_ELEMENT, {
                      element_name: !this.state.viewAll ? 'View All' : 'View Less',
                      option_title: { panelName },
                    });
                  }}
                />
              )}
            </div>}
          </div>
        )}
        {!displaySidebar && displayViewButton && (
          <Button
            type={buttonTypes.SECONDARY.value}
            action={actionTypes.CALL_TO_ACTION.value}
            label={!this.state.viewAll ? 'View All' : 'View Less'}
            style={{ width: '200px', margin: '16px auto', display: 'block' }}
            onClick={() => {
              this.setState({
                viewAll: !this.state.viewAll,
              });
              analytics.track(events.CLICKED_ELEMENT, {
                element_name: !this.state.viewAll ? 'View All' : 'View Less',
                option_title: { panelName },
              });
            }}
          />
        )}
        {isMobile
          && this.hasPanelItems(panelItems)
          && panelItems.length > pageLength
          && !isExpired && (
            <PageNav
              maxPageCount={4}
              currentPage={this.state.currentPage}
              totalPages={Math.ceil(panelItems.length / pageLength)}
              onChange={pg => {
                this.setState({ currentPage: pg });
                scrollToComponent(this.Header, {
                  offset: 0,
                  align: 'top',
                  duration: 500,
                });
              }}
            />
        )}
        {/* User is expired and is viewing a shared box and the box has addons  */}
        {isExpired && isSharedBox && this.hasPanelItems(panelItems) && (
          reactivateCTASharedBoxWithItems
        )}
      </div>
    );
  }
}

export default PanelView;



// WEBPACK FOOTER //
// ./src/Components/Panels/SharedComponents/Panel/Panel.js